/**
 * Created by Ning Jiang on 2021-06-29.
 */

import {WinPresentationController} from "../WinPresentationController";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {gsap} from "gsap";
import {DeadwoodRip} from "../../DeadwoodRip";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";

export class FreespinEndController extends WinPresentationController {

    constructor() {
        super("FreespinEndController", false);
    }

    protected hasWin():boolean {
        const data = DeadwoodRip.model.parsedGameData;
        return data.mode != GameMode.NORMAL && data.nextMode === GameMode.NORMAL && !data.brokeTheBank;
    }

    protected async createWinAnimation():Promise<any> {
        const tl = gsap.timeline();
        let delay = 0.3;
        if(DeadwoodRip.model.parsedGameData.singleWin > 0) {
            delay += 0.3;
        }
        tl.to(this, {duration : delay});
        await Promise.resolve(tl);
        await new Promise<void>(resolve => {
            DeadwoodRip.freespinOutro.show(() => {
                SlotGame.keypadPlugin.setZeroBetSpinCounter(-1);
                resolve();
            });
        });
    }
}